module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('svg', {
    attrs: {
      "id": "orderID"
    }
  })]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 14
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('h2', [_vm._v(_vm._s(_vm.pickingData.StockOut.Warehouse.Name) + " " + _vm._s(_vm.pickingData.StockOut.Freight.Code) + " " + _vm._s(_vm.pickingData.StockOut.Types) + " " + _vm._s(_vm.pickingData.StockOut.OrderID) + " 匹配单")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('h2', [_vm._v("订单总数：" + _vm._s(_vm.countData.OrderAll))])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('h2', [_vm._v("总包裹数：" + _vm._s(_vm.countData.PackageAll))])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.printPage
    }
  }, [_vm._v("打印")])], 1)], 1)], 1), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered table-condensed"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', {}, _vm._l((_vm.pickingData.OutStockOrder), function(t, index) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_c('p', [_c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.formatReferenceID(t.ReferenceID))
      }
    }), _c('br'), _c('span', [_vm._v(_vm._s(t.InsideOrder))])])]), _vm._v(" "), _c('td', _vm._l((t.Package), function(s) {
      return _c('p', {
        staticStyle: {
          "font-size": "18px"
        }
      }, _vm._l((s.Product), function(p) {
        return _c('span', [_vm._v("[" + _vm._s(p.FullSKU) + "] " + _vm._s(p.FullName) + " * " + _vm._s(p.Quantity * s.Quantity))])
      }))
    })), _vm._v(" "), _c('td', [_vm._v(_vm._s(t.Quantity))]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td')])
  }))])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("序号")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "11%"
    }
  }, [_vm._v("运单")]), _vm._v(" "), _c('th', [_vm._v("包含产品")]), _vm._v(" "), _c('th', [_vm._v("包裹数量")]), _vm._v(" "), _c('th', [_vm._v("拣出数量")]), _vm._v(" "), _c('th', [_vm._v("操作人")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0265c94a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/OutStockOrder.vue
// module id = 826
// module chunks = 1